import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/api/errors'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Never serve a stale patient record from cache as if it were current:
        // a doctor reading last month's prescription believing it is today's is
        // a clinical safety issue, not a caching preference.
        staleTime: 0,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            // 4xx means the server answered. Retrying will not change its mind.
            if (error.status >= 400 && error.status < 500) return false
          }
          return failureCount < 2
        },
      },
      mutations: {
        // Mutations never auto-retry. Visit creation carries an idempotency key
        // and retries deliberately; everything else would risk a duplicate.
        retry: false,
      },
    },
  })
}
